module.exports = __webpack_public_path__ + "static/media/coursel_asset_4.03f5ef5b.jpg";